module.exports = __webpack_public_path__ + "assets/img/announcement1.3.b0725365.png";